// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"priority-switcher_dropdown__X0rZv","item":"priority-switcher_item__3s3Xs"};